// ClosingCube — the unfinished cube that sits above the Closing heading:
// the page's last mark, and the only one that keeps moving once it has
// settled. Its edges crawl like every dashed cube's, and one face at a time
// lights up, top, then front-right, then front-left: the same clockwise
// count "How we work" uses for its three points, here as a loading bar that
// steps round the cube and never finishes, because the cube is the company
// and the company is still being drawn. Mounted by
// src/components/sections/Closing.tsx.
//
// This component renders the settled markup and its static CSS position.
// The one-shot settle-in (a small rise as the section arrives) is applied by
// src/motion/markChoreography.ts via the data-mark attribute; the face cycle
// is pure CSS (CubeGlyph.css), paused unless this element carries
// .is-in-view, which the IntersectionObserver below grants only while the
// cube is actually on screen, so the clock never runs above the fold. With
// JS disabled or under reduced motion the cube sits where its CSS puts it,
// top face lit, nothing mid-animation.
import { useEffect, useRef } from 'react';
import { CubeGlyph } from './CubeGlyph';
import './ClosingCube.css';

export function ClosingCube(): JSX.Element {
  const ref = useRef<HTMLSpanElement>(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const io = new IntersectionObserver(([entry]) => {
      el.classList.toggle('is-in-view', entry.isIntersecting);
    });
    io.observe(el);
    return () => io.disconnect();
  }, []);

  return (
    <span ref={ref} className="mark-closing" data-mark="closing-cube">
      <CubeGlyph tone="dash" size={48} cycle />
    </span>
  );
}
